import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Body2,
  Button,
  Col,
  H5,
  Message,
  SmallButton,
  Spacer,
  SpecialContent,
  Text,
} from '../components'
import { saveProperty } from '../helper/LocalStorage'
import { isIOS } from '../helper/userAgents'

type Props = {
  appIsInstalled: boolean
}

// let appIsInstalled = false

// let deferredPrompt

// window.addEventListener('beforeinstallprompt', (event) => {
//   event.preventDefault()
//   deferredPrompt = event
//   // Show your custom install button or take any other action
// })

export const InstallPrompt: React.FC<Props> = ({ appIsInstalled }) => {
  const [installDone, setInstallDone] = React.useState(false)
  const [browserCheckDone, setBrowserCheckDone] = React.useState(false)
  const [deferredPrompt, setDeferredPrompt] = React.useState<any>(undefined)

  const navigate = useNavigate()

  useEffect(() => {
    const listener = (event) => {
      event.preventDefault()
      // const deferredPrompt = event
      setDeferredPrompt(event)

      console.log('beforeinstallprompt event fired', event)
      // Show your custom install button or take any other action
    }

    window.addEventListener('beforeinstallprompt', listener)

    setBrowserCheckDone(true)
    return () => {
      window.removeEventListener('beforeinstallprompt', listener)
    }
  }, [])

  if (appIsInstalled || !browserCheckDone) {
    return null
  }

  if (true) {
    // if (!deferredPrompt) {
    return (
      <Col gap={6} flexDirection="column" alignItems="flex-start">
        <H5>
          <Message id="INSTALL_MANUALLY_HEADLINE" />
        </H5>

        {isIOS ? (
          <Text>
            <Message id="INSTALL_MANUALLY_MESSAGE_IOS" renderRawHtml />
          </Text>
        ) : (
          <Text>
            <Message id="INSTALL_MANUALLY_MESSAGE" renderRawHtml />
          </Text>
        )}

        <Button
          onClick={() => {
            navigate('/instructions')
          }}
        >
          <Message id="INSTALL_INSTRUCTIONS_BUTTON" />
        </Button>
      </Col>
    )
  }

  return (
    <div>
      <Spacer size={2} />
      <SpecialContent>
        <H5>
          <Message id="INSTALL_PROMT_HEADLINE" />
        </H5>
        <Spacer size={1} />
        <Body2>
          <Message id="INSTALL_PROMT_MESSAGE" />
        </Body2>
        <Spacer size={1} />

        <SmallButton
          disabled={installDone}
          onClick={() => {
            if (deferredPrompt) {
              deferredPrompt.prompt()
              deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                  console.log('App installed successfully')
                  setInstallDone(true)
                  saveProperty('appInstalled', true)
                }
                // deferredPrompt = null
              })
            }
          }}
        >
          Install App
        </SmallButton>

        {installDone && <Text>App installed successfully</Text>}
      </SpecialContent>
    </div>
  )
}
